/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=6afc2eb1&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6afc2eb1&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__